import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import './QuoteBanner.css';

export default function QuoteBanner() {
  const navigate = useNavigate();

  const goToLanding = () => navigate('/cotiza-tu-enfermera');

  return (
    <div className="quote_banner" onClick={goToLanding}>
      <div className="quote_banner_icon">
        <LocalHospitalIcon sx={{ fontSize: 36, color: '#fff' }} />
      </div>
      <div className="quote_banner_text">
        <h3>Cotiza múltiples enfermeras aquí</h3>
        <p><b>Ahorra tiempo:</b> cuéntanos qué necesitas y recibe cotizaciones de diferentes enfermeras certificadas en minutos, directamente en tu WhatsApp (entre 08:00 y 21:00 hrs). ¡Compara y elige la mejor opción!</p>
      </div>
      <Button
        variant="contained"
        className="quote_banner_btn"
        onClick={e => { e.stopPropagation(); goToLanding(); }}
      >
        Cotizar ahora
      </Button>
    </div>
  );
}
